import { gql } from "@apollo/client";

export const GET_TOTAL_PRODUCTS = gql`
    query GetTotalProducts {
        products {
            meta {
                pagination {
                    total
                }
            }
        }
    }
`;

export const GET_TOTAL_COLLECTIONS = gql`
    query GetTotalCollections {
        collections {
            meta {
                pagination {
                    total
                }
            }
        }
    }
`;
export const GET_TOTAL_CATEGORIES = gql`
    query GetTotalCategories {
        categories {
            meta {
                pagination {
                    total
                }
            }
        }
    }
`;

export const GET_TOTAL_LUMEN = gql`
    query GetTotalLumen {
        lumens {
            meta {
                pagination {
                    total
                }
            }
        }
    }
`;

export const GET_TOTAL_TEMPERATURE = gql`
    query GetTotalTemperature {
        temperatures {
            meta {
                pagination {
                    total
                }
            }
        }
    }
`;

export const GET_TOTAL_WATTAGE = gql`
    query GetTotalWattage {
        wattages {
            meta {
                pagination {
                    total
                }
            }
        }
    }
`;

export const GET_TOTAL_DISTRIBUTION = gql`
    query GetTotalDistribution {
        distributions {
            meta {
                pagination {
                    total
                }
            }
        }
    }
`;

export const GET_TOTAL_CERTIFICATION = gql`
    query GetTotalCertification {
        certifications {
            meta {
                pagination {
                    total
                }
            }
        }
    }
`;

// export const GET_SEARCH_PRODUCTS = gql`
//     query GetSearchProducts($partName: String!, $limit: Int! = 20) {
//         products(
//             pagination: { start: 0, limit: $limit }
//             filters: { title: { containsi: $partName } }
//         ) {
//             data {
//                 id
//                 attributes {
//                     title
//                     image {
//                         data {
//                             attributes {
//                                 url
//                             }
//                         }
//                     }
//                     spec_pdf {
//                         data {
//                             attributes {
//                                 url
//                             }
//                         }
//                     }
//                 }
//             }
//         }
//     }
// `;

export const GET_SEARCH_COLLECTIONS = gql`
    query GetSearchCollections($partName: String!, $limit: Int! = 20) {
        collections(
            filters: { name: { containsi: $partName } }
            pagination: { start: 0, limit: $limit }
        ) {
            data {
                id
                attributes {
                    name
                    image {
                        data {
                            id
                            attributes {
                                url
                            }
                        }
                    }
                    spec_pdf {
                        data {
                            id
                            attributes {
                                url
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_SEARCH_CATEGORIES = gql`
    query GetSearchCategories(
        $partName: String!
        $totalCategories: Int! = 20
        $totalCollections: Int! = 20
    ) {
        categories(
            sort: "position"
            filters: { name: { containsi: $partName } }
            pagination: { start: 0, limit: $totalCategories }
        ) {
            data {
                id
                attributes {
                    name
                    collections(
                        pagination: { start: 0, limit: $totalCollections }
                    ) {
                        data {
                            id
                            attributes {
                                name
                                image {
                                    data {
                                        attributes {
                                            name
                                            url
                                        }
                                    }
                                }
                                spec_pdf {
                                    data {
                                        attributes {
                                            name
                                            url
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_CATEGORIES = gql`
    query GetCategories($totalProducts: Int! = 20) {
        categories(sort: "position") {
            data {
                id
                attributes {
                    name
                    collections(
                        pagination: { start: 0, limit: $totalProducts }
                    ) {
                        data {
                            id
                            attributes {
                                name
                                image {
                                    data {
                                        attributes {
                                            name
                                            url
                                        }
                                    }
                                }
                                spec_pdf {
                                    data {
                                        attributes {
                                            name
                                            url
                                        }
                                    }
                                }
                                thumbnails {
                                    data {
                                        attributes {
                                            name
                                        }
                                    }
                                }
                                # standard_cct {
                                #   data {
                                #     attributes {
                                #       name
                                #     }
                                #   }
                                # }
                                # wattage {
                                #   data {
                                #     attributes {
                                #       name
                                #     }
                                #   }
                                # }
                                # lumene {
                                #   data {
                                #     attributes {
                                #       name
                                #     }
                                #   }
                                # }
                                # ordering_guide {
                                #  id
                                #  header
                                #  values
                                # }
                                optics {
                                    data {
                                        attributes {
                                            name
                                        }
                                    }
                                }
                                about_section {
                                    id
                                    header
                                    description
                                }
                                features_benefits {
                                    id
                                    features {
                                        id
                                        feature
                                    }
                                    benefits {
                                        id
                                        benefit
                                    }
                                }
                                Gallery_and_Applications {
                                    data {
                                        id
                                        attributes {
                                            name
                                            url
                                            caption
                                        }
                                    }
                                }
                                Description_Details
                                Long_Description
                                About_Family
                                About_Family_Image {
                                    data {
                                        id
                                        attributes {
                                            name
                                            url
                                        }
                                    }
                                }
                                Small_Description
                                Specifications_Output
                                Specifications_Efficacy
                                Specifications_CCTs
                                Specifications_operating_temperature
                                Specifications_warranty
                                Specifications_DLC
                                Description_Details_Title
                                About_Family_Title
                                Specifications_Output_Title
                                Specifications_CCTs_Title
                                Long_Description_Title
                                Small_Description_Title
                                Specifications_Efficacy_Title
                                products {
                                    data {
                                        id
                                        attributes {
                                            title
                                            image {
                                                data {
                                                    id
                                                    attributes {
                                                        name
                                                        url
                                                    }
                                                }
                                            }
                                            collection {
                                                data {
                                                    id
                                                    attributes {
                                                        name
                                                        #       lumene {
                                                        #         data {
                                                        #           id
                                                        #           attributes {
                                                        #             name
                                                        #           }
                                                        #         }
                                                        #       }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_PRODUCTS = gql`
    query GetProducts($totalProducts: Int! = 20) {
        products(pagination: { start: 0, limit: $totalProducts }) {
            data {
                id
                attributes {
                    title
                    image {
                        data {
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    collection {
                        data {
                            attributes {
                                name
                                category {
                                    data {
                                        id
                                        attributes {
                                            name
                                        }
                                    }
                                }
                            }
                        }
                    }
                    lumen {
                        data {
                            attributes {
                                Lumen
                                temperature {
                                    data {
                                        attributes {
                                            key_temperature
                                            value_temperature
                                        }
                                    }
                                }
                            }
                        }
                    }
                    wattages {
                        data {
                            attributes {
                                Watt
                            }
                        }
                    }
                    spec_pdf {
                        data {
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    Photometry_IES_ZIP {
                        data {
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    Instalation_Sheet_PDF {
                        data {
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    Brochure_PDF {
                        data {
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    Warranty_PDF {
                        data {
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    All_Documents_ZIP {
                        data {
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    distributions {
                        data {
                            attributes {
                                Name
                            }
                        }
                    }
                    certifications {
                        data {
                            attributes {
                                Name
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_CATEGORY_BY_FULL_NAME = gql`
    query GetCategoryByFullName(
        $name: String!
        $totalCategories: Int! = 20
        $totalCollections: Int! = 20
        $totalProducts: Int! = 20
    ) {
        categories(
            filters: { name: { eq: $name } }
            pagination: { start: 0, limit: $totalCategories }
        ) {
            data {
                id
                attributes {
                    name
                    collections(
                        pagination: { start: 0, limit: $totalCollections }
                    ) {
                        data {
                            id
                            attributes {
                                name
                                products(
                                    pagination: {
                                        start: 0
                                        limit: $totalProducts
                                    }
                                ) {
                                    data {
                                        id
                                        attributes {
                                            title
                                            image {
                                                data {
                                                    attributes {
                                                        url
                                                    }
                                                }
                                            }
                                            spec_pdf {
                                                data {
                                                    attributes {
                                                        url
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_COLLECTION_CERTIFICATES = gql`
    query GetCertificates {
        certificates {
            data {
                id
                attributes {
                    title
                    image {
                        data {
                            attributes {
                                url
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_COLLECTION_THUMBNAILS = gql`
    query GetThumbnails($productId: ID!) {
        collection(id: $productId) {
            data {
                id
                attributes {
                    thumbnails {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_DATA_FOR_COLLECTION_SPEC_SECTION = gql`
    query GetProductsSpecPhoto($productId: ID!) {
        collection(id: $productId) {
            data {
                id
                attributes {
                    standard_cct {
                        data {
                            attributes {
                                url
                            }
                        }
                    }
                    wattage {
                        data {
                            attributes {
                                url
                            }
                        }
                    }
                    lumene {
                        data {
                            attributes {
                                url
                            }
                        }
                    }
                    optics {
                        data {
                            attributes {
                                url
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_COLLECTION_IMAGE = gql`
    query GetProductImage($id: ID!) {
        collection(id: $id) {
            data {
                id
                attributes {
                    name
                    image {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_RELATED_PRODUCTS = gql`
    query GetRelatedProducts($id: ID!, $limit: Int! = 20) {
        collection(id: $id) {
            data {
                id
                attributes {
                    products(pagination: { start: 0, limit: $limit }) {
                        data {
                            id
                            attributes {
                                title
                                image {
                                    data {
                                        attributes {
                                            url
                                        }
                                    }
                                }
                                spec_pdf {
                                    data {
                                        attributes {
                                            url
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_SEARCH_KEYWORDS = gql`
    query GetSearchKeywords {
        keywords {
            data {
                attributes {
                    keyword
                }
            }
        }
    }
`;

// export const GET_SEARCH_KEYWORD_PRODUCTS = (conditionForKeywords) => {
//     return gql`
//         query GetSearchKeywordsProducts($name: String!) {
//             products(filters: {
//                 ${`and: [
//                             {
//                                 or: [
//                                     ${conditionForKeywords}
//                                 ]
//                             }
//                         ]`}
//                 collection: { name: { eq: $name } } }) {
//                 data {
//                    id
//                     attributes {
//                                                 title
//                                                 image {
//                                                     data {
//                                                         attributes {
//                                                             url
//                                                         }
//                                                     }
//                                                 }
//                                                 spec_pdf {
//                                                     data {
//                                                         attributes {
//                                                             url
//                                                         }
//                                                     }
//                                                 }
//                                             }
//                 }
//             }
//         }
//     `;
// };

export const GET_SEARCH_KEYWORDS_COLLECTIONS = conditionForKeywords => {
    return gql`
        query GetSearchKeywordsProducts($limit: Int! = 20) {
            collections(
                filters: {
                    or: [
                        ${conditionForKeywords}
                    ]
                }
                pagination: { start: 0, limit: $limit }
            ) {
                data {
                    id
                    attributes {
                        name
                        image {
                            data {
                                attributes {
                                    url
                                }
                            }
                        }
                        spec_pdf {
                            data {
                                attributes {
                                    url
                                }
                            }
                        }
                    }
                }
            }
        }
    `;
};

export const GET_SEARCH_KEYWORDS_CATEGORIES = conditionForKeywords => {
    return gql`
        query GetSearchCategories(
            $totalCategories: Int! = 20
            $totalCollections: Int! = 20
        ) {
            categories(
                sort: "position"
                filters: { or: [${conditionForKeywords}] }
                pagination: { start: 0, limit: $totalCategories }
            ) {
                data {
                    id
                    attributes {
                        name
                        collections(
                            pagination: { start: 0, limit: $totalCollections }
                        ) {
                            data {
                                id
                                attributes {
                                    name
                                    image {
                                        data {
                                            attributes {
                                                name
                                                url
                                            }
                                        }
                                    }
                                    spec_pdf {
                                        data {
                                            attributes {
                                                name
                                                url
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `;
};

export const GET_ORDERING_GUIDE = gql`
    query GetOrderingGuide($name: String!) {
        collections(filters: { name: { eq: $name } }) {
            data {
                id
                attributes {
                    ordering_guide {
                        id
                        header
                        values
                    }
                }
            }
        }
    }
`;

export const GET_ABOUT_SECTION = gql`
    query GetAboutSection($name: String!) {
        collections(filters: { name: { eq: $name } }) {
            data {
                id
                attributes {
                    about_section {
                        header
                        description
                    }
                }
            }
        }
    }
`;

export const GET_FEATURES_BENEFITS = gql`
    query GetFeaturesBenefits($name: String!) {
        collections(filters: { name: { eq: $name } }) {
            data {
                id
                attributes {
                    features_benefits {
                        id
                        features {
                            feature
                        }
                        benefits {
                            benefit
                        }
                    }
                }
            }
        }
    }
`;

export const GET_COLLECTION_ID = gql`
    query GetCollectionId($name: String!) {
        collections(filters: { name: { eq: $name } }) {
            data {
                id
            }
        }
    }
`;

export const GET_NETPRODUCT = gql`
    query GetNewProducts {
        newProducts {
            data {
                id
                attributes {
                    product_name
                    lumen_output
                    image {
                        data {
                            id
                            attributes {
                                name
                                url
                                size
                            }
                        }
                    }
                    product_category {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_OUR_REP = gql`
    query GetOurReps {
        ourReps(pagination: { start: 0, limit: 50 }) {
            data {
                id
                attributes {
                    company_name
                    company_address
                    company_phone
                    company_website
                    region_in_state
                    state {
                        data {
                            id
                            attributes {
                                Name
                                Short_Name
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_RESOURCE = gql`
    query GetResource($name: String!) {
        collections(filters: { name: { eq: $name } }) {
            data {
                id
                attributes {
                    name
                    spec_pdf {
                        data {
                            id
                            attributes {
                                name
                                url
                                size
                                updatedAt
                            }
                        }
                    }
                }
            }
        }
        resourcesAndDownloads(
            filters: { collections: { name: { eq: $name } } }
        ) {
            data {
                id
                attributes {
                    PhotometryIES_zip {
                        data {
                            id
                            attributes {
                                name
                                url
                                size
                                updatedAt
                            }
                        }
                    }
                    InstalationSheet_pdf {
                        data {
                            id
                            attributes {
                                name
                                url
                                size
                                updatedAt
                            }
                        }
                    }
                    Brochure_pdf {
                        data {
                            id
                            attributes {
                                name
                                url
                                size
                                updatedAt
                            }
                        }
                    }
                    Warranty_pdf {
                        data {
                            id
                            attributes {
                                name
                                url
                                size
                                updatedAt
                            }
                        }
                    }
                    collections {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                    AllDocuments_zip {
                        data {
                            id
                            attributes {
                                name
                                url
                                size
                                updatedAt
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_DISTRIBUTION = gql`
    query GetDistribution($category: String!, $collection: String!) {
        distributions(
            filters: {
                category: { name: { eq: $category } }
                collection: { name: { eq: $collection } }
            }
        ) {
            data {
                id
                attributes {
                    Abbreviation
                    Name
                    Image {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_DISTRIBUTION_NAME = gql`
    query GetDistribution($totalDistribution: Int! = 20) {
        distributions(pagination: { start: 0, limit: $totalDistribution }) {
            data {
                id
                attributes {
                    Abbreviation
                    Name
                    Image {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    category {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                    collection {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                    product {
                        data {
                            id
                            attributes {
                                title
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_CERTIFICATION = gql`
    query GetCertification($category: String!, $collection: String!) {
        certifications(
            filters: {
                category: { name: { eq: $category } }
                collection: { name: { eq: $collection } }
            }
        ) {
            data {
                id
                attributes {
                    Name
                    Image {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_WATTAGE = gql`
    query GetWattage($category: String!, $collection: String!) {
        wattages(
            filters: {
                category: { name: { eq: $category } }
                collection: { name: { eq: $collection } }
            }
        ) {
            data {
                id
                attributes {
                    Watt
                    product {
                        data {
                            id
                            attributes {
                                title
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_WATTAGE_NAME = gql`
    query GetWattage($totalWattage: Int! = 20) {
        wattages(pagination: { start: 0, limit: $totalWattage }) {
            data {
                id
                attributes {
                    Watt
                    collection {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                    category {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                    product {
                        data {
                            id
                            attributes {
                                title
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_CERTIFICATION_NAME = gql`
    query GetCertification($totalCertification: Int! = 20) {
        certifications(pagination: { start: 0, limit: $totalCertification }) {
            data {
                id
                attributes {
                    Name
                    collection {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                    category {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                    product {
                        data {
                            id
                            attributes {
                                title
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_ACCESSOTIRES = gql`
    query GetAccessories($category: String!, $collection: String!) {
        accessories(
            filters: {
                category: { name: { eq: $category } }
                collection: { name: { eq: $collection } }
            }
        ) {
            data {
                id
                attributes {
                    Image {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    Abreviation
                    Name
                    category {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                    collection {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_TEMPERATURE = gql`
    query GetTemperature($collection: String, $totalTemperature: Int! = 20) {
        temperatures(
            filters: { collection: { name: { eq: $collection } } }
            pagination: { start: 0, limit: $totalTemperature }
        ) {
            data {
                id
                attributes {
                    key_temperature
                    value_temperature
                    collection {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                    lumen {
                        data {
                            id
                            attributes {
                                Lumen
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_PLATESTYLE = gql`
    query GetPlateStyle($category: String!, $collection: String!) {
        plateStyles(
            filters: {
                category: { name: { eq: $category } }
                collection: { name: { eq: $collection } }
            }
        ) {
            data {
                id
                attributes {
                    Abbreviation
                    Name
                }
            }
        }
    }
`;

export const GET_OPTION = gql`
    query GetOptions($category: String!, $collection: String!) {
        options(
            filters: {
                category: { name: { eq: $category } }
                collection: { name: { eq: $collection } }
            }
        ) {
            data {
                id
                attributes {
                    Abbreviation
                    Name
                }
            }
        }
    }
`;

export const GET_CATEGORIES_NAME = gql`
    query GetCategoriesName($totalCategories: Int! = 20) {
        categories(pagination: { start: 0, limit: $totalCategories }) {
            data {
                id
                attributes {
                    name
                }
            }
        }
    }
`;

export const GET_COLLECTIONS_NAME = gql`
    query GetCollectionName($totalCollections: Int! = 20) {
        collections(
            pagination: { start: 0, limit: $totalCollections }
            sort: "name:asc"
        ) {
            data {
                id
                attributes {
                    name
                    category {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_COLLECTIONS_RELATE = gql`
    query GetCollectionName(
        $totalCollections: Int! = 20
        $Category: String!
        $Collection: String!
    ) {
        collections(
            pagination: { start: 0, limit: $totalCollections }
            sort: "name:asc"
            filters: {
                category: { name: { eq: $Category } }
                name: { ne: $Collection }
            }
        ) {
            data {
                id
                attributes {
                    name
                    image {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_LUMEN = gql`
    query GetLumen($totalLemun: Int! = 20) {
        lumens(
            sort: "Lumen:asc"
            pagination: { start: 0, limit: $totalLemun }
        ) {
            data {
                id
                attributes {
                    category {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                    collection {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                    product {
                        data {
                            id
                            attributes {
                                title
                            }
                        }
                    }
                    Lumen
                    temperature {
                        data {
                            id
                            attributes {
                                key_temperature
                                value_temperature
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_WARRANT_DOC = gql`
    query GetWarrantDoc {
        warrantyDocs {
            data {
                id
                attributes {
                    Warranty_Ten_Years {
                        data {
                            id
                            attributes {
                                name
                                size
                                url
                                updatedAt
                            }
                        }
                    }
                    Warranty_five_years {
                        data {
                            id
                            attributes {
                                name
                                size
                                url
                                updatedAt
                            }
                        }
                    }
                    Terms_and_Conditions {
                        data {
                            id
                            attributes {
                                name
                                size
                                url
                                updatedAt
                            }
                        }
                    }
                    Insurance_policy_summary {
                        data {
                            id
                            attributes {
                                name
                                size
                                url
                                updatedAt
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_NEW_CASE_STUDIES = gql`
    query GetNewCaseStudies {
        newCaseStudies {
            data {
                id
                attributes {
                    Image_New_Case_Study {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    Title_New_case_study
                    collection {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                    category {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                    Invisible_URL_Position_field
                }
            }
        }
    }
`;

export const GET_CASE_STUDIES = gql`
    query GetCaseStudies {
        caseStudies(sort: "createdAt:desc") {
            data {
                id
                attributes {
                    Image {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    PDFFileForEmailSend {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    Title_Case_Study
                    Location_Case_Study
                    Content_Case_Study
                    createdAt
                }
            }
        }
    }
`;

export const GET_CUSTOM_PROJECTS = gql`
    query GetCustomProjects {
        customWorks(sort: "createdAt:desc") {
            data {
                id
                attributes {
                    PDFFile {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    Title
                    createdAt
                }
            }
        }
    }
`;

export const GET_CUSTOM_FABRICATION = gql`
    query GetCustomFabrication {
        customFabrications {
            data {
                id
                attributes {
                    PageTitle
                    ImageBanner {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    Capabilities
                    CapabilitiesDescription
                    ServicesTitle
                    ContractManufacturingTtitle
                    ContractManufacturingDescription
                    PrototypingTitle
                    PrototypingDescription
                    ThreeDModelingTitle
                    ThreeDModelingDescription
                    LaserCutingTitle
                    LaserCuttingDescriptions
                    LaserCuttingImage {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    LaserWeldingTitle
                    LaserWeldingDescription
                    LaserWeldingImage {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    BendingAndHardwareInsertionTitle
                    BendingAndCuttingInsertionDescription
                    BendingAndHardwareInsertionImage {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    LaserEtching
                    LaserEtchingDescription
                    LaserEtchingImage {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    PowderCoatingTitle
                    PowderCoatingDescription
                    PowderCoatingImage {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    CustomFabricationProjectGallery
                    CustomFabricationProjectGalleryImage {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    CustomLightingProjects
                    CustomLightingProjectsImage {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    YoutubeVideoUrl
                    createdAt
                }
            }
        }
    }
`;

export const GET_BANNER = gql`
    query GetBanner {
        banners(sort: "createdAt:desc") {
            data {
                id
                attributes {
                    BannerImage {
                        data {
                            id
                            attributes {
                                name
                                url
                            }
                        }
                    }
                    BannerText
                    createdAt
                }
            }
        }
    }
`;
